import { createAction } from '@reduxjs/toolkit'
import { TReportWidget } from 'types/GlobalWidget'

import { TParsedError } from 'utils/errorParser'

// tryGetOneReportWidget
export const getOne = createAction<{
  id: string
  fetchId: string
}>('get_one_report_widget')
export const getOneSuccess = createAction<{
  data: TReportWidget
  fetchId: string
}>('get_one_report_widget_success')
export const getOneFailed = createAction<{
  widgetId: string
  fetchId: string
  error: TParsedError
}>('get_one_report_widget_failed')

// tryDeleteReportWidget
export const destroy = createAction('destroy_report_widget')
export const destroySuccess = createAction<{
  id: string
  reportId: string
  deletedBlockId: string | null
}>('destroy_report_widget_success')
export const destroyFailed = createAction('destroy_report_widget_failed')

// tryUpdateReportWidget
export const update = createAction('update_report_widget')
export const updateSuccess = createAction<{
  data: TReportWidget
  skipFetchData: boolean
}>('update_report_widget_success')
export const updateFailed = createAction('update_report_widget_failed')

// tryEditDataReportWidget
export const editDataPending = createAction<{ id: string }>(
  'edit_data_report_widget_pending'
)
export const editDataFailed = createAction<{ id: string }>(
  'edit_data_report_widget_failed'
)
